import React from "react";
import { Link } from "react-router-dom";
import "../programs/Programs.css";
import moment from "moment";

const Patients = (props) => {
  return (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        <input
          type="text"
          ref={props.searchPatients}
          placeholder={"Enter Patient name"}
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.searchPatients.current.value)}
        />
        <div className="top_hold_buttons">
          <div className="programs_menu"></div>
        </div>
      </div>
      
      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">

      {props.patientsData.length && !props.notFoundError > 0 ? (
        <div className="programs_table">
          <div className="programs_cols">
            {props.selectedTab !== "Protocols" && (
              <div className="programs_col_info">
                <div className="programs_col_name">Patient Name</div>
                <div
                  className="programs_col_icon"
                  onClick={() => props.handleSorting("patient_name", props.patientsData)}
                ></div>
              </div>
            )}
            <div className="programs_col_info">
              <div className="programs_col_name">Patient Status</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("status", props.patientsData)}
              ></div>
            </div>
            <div className="programs_col_info">
              <div className="programs_col_name">Start Date</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("patients_start_date", props.patientsData)}
              ></div>
            </div>

            <div className="programs_col_info">
              <div className="programs_col_name">Days in</div>
              <div
                className="programs_col_icon"
                onClick={() => props.handleSorting("days_in", props.patientsData)}
              ></div>
            </div>
          </div>
        </div>
      )
       : 
      // !props.loading ? 
      (
        <div className="programs_table_no_content">
          <div className="no_content_notice_contain">
            {props.contentLoaded && props.notFoundError ? (
              <>
                <div className="programs_no_results_img"></div>
                <div className="programs_no_res_main">
                  You have no active {props.selectedTab === "Patients" ? "patients " : ""}
                </div>
                <div className="programs_no_res_elab">
                  You have 0 active {props.selectedTab === "Patients" ? "patients " : ""}
                </div>
              </>
            ) : (
              <div className="p_load"></div>
            )}
          </div>
        </div>
      )
      //  : (
      //   <div className="programs_table_no_content">
      //     <div className="no_content_notice_contain">
      //     <div className="p_load"></div>
      //     </div>
      //   </div>
      // )
      }
      <div className="tbl_content_hold">
        {props.patientsData && !props.notFoundError &&
          props.patientsData.map((item, i) => (
            <div key={i} className="programs_tbl_content current_patient_mark">
              <Link
                to={"/patient-details/" + item.patient_id + "/" + item.program_id}
                style={{ textDecoration: "none" }}
                onClick={() => localStorage.removeItem("from_messages")}
              >
                <div className="programs_tbl_row">
                  {props.selectedTab !== "Protocols" && (
                    <div className="programs_tbl_col_contain">
                      <div className="programs_tbl_col">{item.patient_name}</div>
                    </div>
                  )}
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.status}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{moment(item.patients_start_date).format("L")}</div>
                  </div>
                  <div className="programs_tbl_col_contain">
                    <div className="programs_tbl_col">{item.days_in}</div>
                  </div>

                  <div className="programs_tbl_col programs_tbl_col_last" style={{ height: 0 }}>
                    ...
                  </div>
                </div>
              </Link>
            </div>
          ))}
      </div>
      
    </div>
    </div>
    </div>
  );
};

export default Patients;
